import { useCallback } from 'react';
import { useAppStore } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
export const useSmartRulesNavigation = () => {
    const { navigateDeprecated } = useMainStackNavigation();
    const store = useAppStore();
    const startCreateFlow = useCallback(() => navigateDeprecated('SmartRuleName'), []);
    const onPressSmartRules = useCallback((isCreateFlow) => {
        const { didViewSmartRulesIntro } = store.getState().deviceSettings;
        const hasRule = store.getState().smartRules.rules?.length;
        if (didViewSmartRulesIntro || hasRule) {
            if (isCreateFlow === true) {
                startCreateFlow();
                return;
            }
            navigateDeprecated('SmartRules');
        }
        else {
            navigateDeprecated('SmartRuleIntro');
        }
    }, [startCreateFlow]);
    return { onPressSmartRules, startCreateFlow };
};
